import React from 'react';
import Color from '../../domain/Color';
import get_bundle from '../../domain/get_bundle';
import Locale from '../../domain/Locale';
import Product from '../../domain/Product';
import SponsorDomain from '../../domain/Sponsor';
import Layout from '../../components/Layout';
import Sponsor from '../../components/Sponsor';
import { t, props } from 'tcomb-react';

@props({
  locale: Locale,
  product: Product,
  sponsor: t.maybe(SponsorDomain),
  themeBtnColor: t.maybe(Color),
  themeBgColor: t.maybe(Color),
  themeBtnFontColor: t.maybe(Color),
  themeBgFontColor: t.maybe(Color),
  showLatticeUrl: t.Bool,
  goCatalog: t.Func,
  doAcceptCookies: t.Func,
  partners: t.maybe(t.Obj)
})
export default class ProductNotAvailable extends React.Component {

  getBgColor() {
    if (!this.props.sponsor) {
      return null;
    }
    return this.props.sponsor.bg_color;
  }

  getColor() {
    if (!this.props.sponsor) {
      return null;
    }
    return this.props.sponsor.color;
  }

  getGoCatalogLink() {
    if (!this.props.goCatalog) {
      return null;
    }

    const btnStyle = {
      backgroundColor: this.props.themeBtnColor,
      color: this.props.themeBtnFontColor
    };
    return (<button className='message_button' style={btnStyle} onClick={this.props.goCatalog}>{get_bundle(this.props.locale).product_not_available.go_catalog}</button>);
  }

  goCatalog = (evt) => {
    evt.preventDefault();
    this.props.goCatalog();
  }

  getSponsor() {
    const options = {
      is_welcome: true,
      showTutorial: false
    };
    return (<Sponsor sponsor={this.props.sponsor} locale={this.props.locale} options={options} />);
  }

  getStyleMessage() {
    if (!this.props.themeBgColor) {
      return null;
    }
    return {
      backgroundColor: this.props.themeBgColor,
      color: this.props.themeBgFontColor
    };
  }

  render() {
    const { locale, product } = this.props;
    const bundle = get_bundle(locale).product_not_available;
    return (
      <Layout sponsor={this.getSponsor()} partners={this.props.partners} bgColor={this.getBgColor()} locale={locale} doAcceptCookies={this.props.doAcceptCookies}>
        <div id='product_not_available'>
          <div className='cols'>
            <div className='large-50 small-hide'>
              <div className='cell'>
                <div className='product-box'>
                  <img alt={product.name} src={product.image}/>
                  <div className='caption'>
                    <h1>{product.name}</h1>
                    <p>{product.description}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className='large-50 small-100'>
              <div className='cell'>
                <div className='box dark message border-radius-all' style={this.getStyleMessage()}>
                  <h2>{bundle.title}</h2>
                  <br/>
                  {this.getGoCatalogLink()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}




/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/product/route/ProductNotAvailable.js
 **/